import Vue from 'vue'
import VueCookies from 'vue-cookies'
import router from '../../router'
import api from '../../api/leadRealAPI'

Vue.use(VueCookies)

export default {
  namespaced: true,
  state: {
    body: null
  },

  getters: {
  },

  mutations: {
  },
  actions: {
    sendEmail ({ commit }, data) {
      api
        .post('/member/contactUs', data)
        .then(response => {
          if (response.status === 200) {
            router.push({ name: 'Client Contact Confirmation' }).catch(() => {})
          }
        }).catch(() => {})
    }
  }
}
